import React from 'react';
import styled from 'styled-components';
import {hover, regular, text, title, title_ms60} from "../styles/globalStyleVars";
import ReactHtmlParser from "react-html-parser";

const Title = ({
                   text,
                   fontSize,
                   fontWeight,
                   color,
                   letterSpacing,
                   lineHeight,
                   textTransform,
                   margin,
                   padding,
                   borderColor,
                   varient,
                   center,
                   classname,
                   mobileFontSize,
                   mobileLineHeight,
                   fontFamily,
                   small_text
               }) => {


    return (

        <StyledTitle className={`title fade-up ${classname}`}
                     fontSize={fontSize}
                     fontWeight={fontWeight}
                     color={color}
                     lineHeight={lineHeight}
                     LetterSpacing={letterSpacing}
                     textTransform={textTransform}
                     margin={margin}
                     padding={padding}
                     varient={varient}
                     center={center}
                     borderColor={borderColor}
                     mobileFontSize={mobileFontSize}
                     mobileLineHeight={mobileLineHeight}
                     fontFamily={fontFamily}
        >
            {
                text && <h2 className={'split-up'}>{ReactHtmlParser(text)} </h2>
            }
        </StyledTitle>

    )
};


const StyledTitle = styled.div`
  margin: ${props => props.margin || '0px'};
  position: relative;
  width: 100%;
  font-family: ${title};
  text-align: ${props => props?.center ? 'center' : ''};
  padding: ${p => p.padding};

  h2 {
    font-size: ${props => props.fontSize || 16}px;
    line-height: ${props => props.lineHeight || 20}px;
    //text-transform: uppercase;
    font-weight: ${props => props.fontWeight || '400'};
    color: ${props => props.color || text};
    font-family: ${props => props.fontFamily || `${regular}`};
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(156, 171, 185, 0.2);
  }


  @media (max-width: 767px) {
    margin-bottom: 40px;
    padding: 0;
    h2 {
      font-size: ${props=>props.mobileFontSize ? props.mobileFontSize : 16}px;
      line-height: ${props=>props.mobileLineHeight ? props.mobileLineHeight : 20}px;
    }
  }
`;


export default Title;














